import Popover from '@mui/material/Popover';

import { RenameProjectForm } from './rename-project-form.js';

export type RenameProjectPopoverProps = {
	currentName: string;
	visible: { anchorEl: HTMLElement } | false;
	loading?: boolean;
	onSubmit: (name: string) => void;
	onCancel: () => void;
};

export function RenameProjectPopover({
	currentName,
	visible,
	loading = false,
	onSubmit,
	onCancel,
}: RenameProjectPopoverProps) {
	return (
		<Popover
			anchorEl={visible === false ? undefined : visible.anchorEl}
			anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
			transformOrigin={{ horizontal: 'right', vertical: 'top' }}
			open={visible !== false}
			onClose={onCancel}
		>
			{visible !== false && (
				<RenameProjectForm currentName={currentName} isSubmitting={loading} onSubmit={onSubmit} onCancel={onCancel} />
			)}
		</Popover>
	);
}
